import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import MarketInfoModel from '../models/MarketInfoModel';
import { MarketInfoType } from '../models/MarketInfoQueryModel';

interface MarketInfoInputState {
    input: MarketInfoModel,
    selectedMarketInfoId: number,
    MarketInfoInputExpand: boolean,
    triggerFocusVesselNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
    inputExpand: boolean,
    triggerSelectMarketInfo: number
}

const initialState: MarketInfoInputState = {
    input: {
        id: 0,
        updatedDate: "",
        updatedBy: 0,
        chartererId: null,
        tonnageId: null,
        cargoTypeId: null,
        ownerId: null,
        duration: null,
        chartererRate: null,
        ownerRate: null,
        remarks: "",
        size: null,
        tonnageVesselName: "",
        ownerName: "",
        chartererName: "",
        cargoTypeName: "",
        type: MarketInfoType.Voy,
        loadPort: null,
        disport: null,
    } as MarketInfoModel,
    selectedMarketInfoId: 0,
    MarketInfoInputExpand: true,
    triggerFocusVesselNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
    inputExpand: true,
    triggerSelectMarketInfo: 0
}

export const MarketInfoInputSlice = createSlice({
    name: "MarketInfoInput",
    initialState,
    reducers: {
        setMarketInfoInputId: (state, action: PayloadAction<number>) => {
            state.input.id = action.payload;
        },
        setMarketInfoInput: (state, action: PayloadAction<MarketInfoModel>) => {
            state.input = action.payload;
        },
        setChartererId: (state, action: PayloadAction<string | null>) => {
            state.input.chartererId = action.payload;
        },
        setTonnageId: (state, action: PayloadAction<string | null>) => {
            state.input.tonnageId = action.payload;
        },
        setCargoTypeId: (state, action: PayloadAction<number>) => {
            state.input.cargoTypeId = action.payload;
        },
        setDuration: (state, action: PayloadAction<number | null>) => {
            state.input.duration = action.payload;
        },
        setChartererRate: (state, action: PayloadAction<number | null>) => {
            state.input.chartererRate = action.payload;
        },
        setOwnerRate: (state, action: PayloadAction<number | null>) => {
            state.input.ownerRate = action.payload;
        },
        setRemarks: (state, action: PayloadAction<string>) => {
            state.input.remarks = action.payload;
        },
        setSize: (state, action: PayloadAction<number | null>) => {
            state.input.size = action.payload;
        },
        setTonnageVesselName: (state, action: PayloadAction<string | null>) => {
            state.input.tonnageVesselName = action.payload;
        },
        setOwnerName: (state, action: PayloadAction<string | null>) => {
            state.input.ownerName = action.payload;
        },
        setOwnerId: (state, action: PayloadAction<string | null>) => {
            state.input.ownerId = action.payload;
        },
        setChartererName: (state, action: PayloadAction<string | null>) => {
            state.input.chartererName = action.payload;
        },
        setCargoTypeName: (state, action: PayloadAction<string | null>) => {
            state.input.cargoTypeName = action.payload;
        },
        setType: (state, action: PayloadAction<MarketInfoType>) => {
            state.input.type = action.payload;
        },
        setLoadPort: (state, action: PayloadAction<number | null>) => {
            state.input.loadPort = action.payload;
        },
        setDisport: (state, action: PayloadAction<number | null>) => {
            state.input.disport = action.payload;
        },
        setSelectedMarketInfoId: (state, action: PayloadAction<number>) => {
            state.selectedMarketInfoId = action.payload;
        },
        setMarketInfoInputExpand: (state, action: PayloadAction<boolean>) => {
            state.MarketInfoInputExpand = action.payload;
        },
        setTriggerFocusVesselNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusVesselNameInput = action.payload;
        },
        resetMarketInfoInput: (state) => {
            state.input = initialState.input;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setInputExpand: (state, action: PayloadAction<boolean>) => {
            state.inputExpand = action.payload;
        },
        setTriggerSelectMarketInfo: (state, action: PayloadAction<number>) => {
            state.triggerSelectMarketInfo = action.payload;
        },
    }
});

export const MarketInfoInputSelector = createSelector(
    (state: RootState) => state.marketInfoInput,
    (data) => data
);

export const {
    setMarketInfoInputId,
    setMarketInfoInput,
    setChartererId,
    setTonnageId,
    setCargoTypeId,
    setDuration,
    setChartererRate,
    setOwnerId,
    setLoadPort,
    setDisport,
    setOwnerRate,
    setSize,
    setTonnageVesselName,
    setOwnerName,
    setChartererName,
    setCargoTypeName,
    setType,
    setRemarks,
    setSelectedMarketInfoId,
    setMarketInfoInputExpand,
    setTriggerFocusVesselNameInput,
    resetMarketInfoInput,
    setTriggerSave,
    setTriggerRefreshInput,
    setInputExpand,
    setTriggerSelectMarketInfo
} = MarketInfoInputSlice.actions;

export default MarketInfoInputSlice.reducer;